import * as React from "react";

function ScrewdriverWrenchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M331.8 224.1c28.29 0 54.88 10.99 74.86 30.97l19.59 19.59c40.01-17.74 71.25-53.3 81.62-96.65 5.725-23.92 5.34-47.08.215-68.4-2.613-10.88-16.43-14.51-24.34-6.604l-68.9 68.9h-75.6V97.2l68.9-68.9c7.912-7.912 4.275-21.73-6.604-24.34-21.32-5.125-44.48-5.51-68.4.215-55.3 13.23-98.39 60.22-107.2 116.4C224.5 128.9 224.2 137 224.3 145l82.78 82.86c8.12-2.76 16.42-3.76 24.72-3.76zm52.2 54.5c-23.16-23.16-57.57-27.57-85.39-13.9L191.1 158V95.99L64 0 0 63.1l96 127.1 62.04.008 106.7 106.6c-13.67 27.82-9.251 62.23 13.91 85.39l117 117.1c14.62 14.5 38.21 14.5 52.71-.002l52.75-52.75c14.5-14.5 14.5-38.08-.002-52.71L384 278.6zM227.9 307l-59.2-59.1L19.8 396.8c-26.37 26.37-26.37 69.08 0 95.45C32.96 505.4 50.21 512 67.5 512s34.54-6.592 47.72-19.78l119.1-119.1C225.5 352.3 222.6 329.4 227.9 307zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.7 24 24-10.75 24-24 24z"
  }));
}

const ForwardRef = React.forwardRef(ScrewdriverWrenchIcon);
export default ForwardRef;